import React from 'react';
import { Router } from '@router/routes';

const App: React.FC = () => {
  return <Router />;
};

export { App };
